import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


/**
 * Announces check-ins performed from within the Staff Site itself, so that a
 * page already on screen can react to one immediately.
 *
 * The Customer Detail page polls for check-ins (PRO-1449) because the usual
 * check-in happens at the Check-In Site, outside this browser tab, where
 * polling is the only way to find out. A check-in made from the profile's own
 * "Manual Check-In" button is different: the app knows the moment the request
 * succeeds, so waiting up to a poll interval to notice it would be needless.
 * The sub-list that performs the check-in has no other way to reach the parent
 * profile - it is a routed child, not a content child - hence this service.
 */
@Injectable({
  providedIn: 'root'
})
export class CheckInNotifierService {

  private readonly customerCheckedInSubject = new Subject<number>();

  /**
   * Emits the API ID of a customer who has just been checked in from within
   * the Staff Site.
   */
  public readonly customerCheckedIn: Observable<number> =
    this.customerCheckedInSubject.asObservable();

  /**
   * Announce that a customer has just been checked in.
   *
   * @param customerId - The API ID of the customer who was checked in.
   */
  public notifyCustomerCheckedIn(customerId: number): void {
    this.customerCheckedInSubject.next(customerId);
  }
}
